import React from 'react';
import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Event as EventIcon } from '@mui/icons-material';

const DashboardLink = () => {
  const navigate = useNavigate();

  return (
    <Box 
      display="flex" 
      justifyContent="center" 
      alignItems="center" 
      sx={{ width: '100%', py: 4 }}
    >
      <Button
        variant="contained"
        startIcon={<EventIcon />}
        onClick={() => navigate('/admin/events')}
        sx={{
          bgcolor: '#6C5DD3', 
          '&:hover': {
            bgcolor: '#7c6fe0', 
          },
          px: 4,
          borderRadius: '8px',
          textTransform: 'none',
          fontWeight: 600
        }}
      >
        Events Dashboard
      </Button>
    </Box>
  );
};

export default DashboardLink;